import React, { useEffect } from "react";
import { motion } from "framer-motion";
import "./SplashScreen.css";

const SplashScreen = ({ onFinish = () => { } }) => {
    useEffect(() => {
        const t = setTimeout(() => onFinish(), 3200);
        return () => clearTimeout(t);
    }, [onFinish]);

    const wordmark = {
        initial: { opacity: 0, y: 18 },
        animate: { opacity: 1, y: 0, transition: { duration: 0.55, ease: [0.16, 1, 0.3, 1] } },
    };

    const ring = (delay) => ({
        initial: { scale: 0.3, opacity: 0 },
        animate: {
            scale: [0.3, 3.6],
            opacity: [0, 0.45, 0],
            transition: { delay, duration: 1.4, ease: "easeOut", repeat: Infinity, repeatDelay: 0.4 },
        },
    });

    const dots = {
        initial: { opacity: 0 },
        animate: { opacity: 1, transition: { delay: 0.8, duration: 0.35 } },
    };

    const wrapper = {
        initial: { opacity: 1 },
        animate: {
            opacity: [1, 1, 0],
            transition: { delay: 2.7, duration: 0.5, ease: "easeInOut" },
        },
    };

    return (
        <motion.div className="splash-screen" initial="initial" animate="animate" variants={wrapper}>

            {/* Wordmark */}
            <motion.div className="splash-wordmark" variants={wordmark}>
                <span className="splash-near">near</span><span className="splash-beee">beee</span>
            </motion.div>

            {/* Radar rings */}
            <div className="splash-rings-wrap">
                {[0, 0.22, 0.44].map((delay, i) => (
                    <motion.div key={i} className="splash-ring" variants={ring(delay)} initial="initial" animate="animate" />
                ))}
                <div className="splash-center-dot" />
            </div>

            {/* Two dots */}
            <motion.div className="splash-dots-row" variants={dots}>
                <span className="splash-dot splash-dot-lg" />
                <span className="splash-dot splash-dot-sm" />
            </motion.div>

        </motion.div>
    );
};

export default SplashScreen;
